export default import.meta.ROLLUP_FILE_URL_Zt3Yofi7Zuxpn6ubVtk5Aw